// extracted by mini-css-extract-plugin
export default {"container":"S0-z","list":"T0-z"};